<template>
    <div>

      <!--CADASTRAR NOVO EMAIL-->
      <ed-modal 
        :title="'Enviar Novo Email Lote'+this.parent.formData.lote" 
        :modal="showFormRegister" 
        :loadingSave="config.loading.save"
        :onSave="salvar"
        width="60%"
      >
        <div slot="modal-content" v-loading="config.loading.content">
          <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
            <div slot="form-footer"></div>
          </ed-form>
        </div>
      </ed-modal>

      <!--LISTAR EMAILS-->
      <ed-modal 
        :title="'Emails Lote '+this.parent.formData.lote" 
        :modal="showFormList" 
        width="98%"
      >
        <div slot="modal-content">
          <LogEmail point_type="esocial-lote" :point_id="parent.formData.id" :onRegister="onRegister"/>
        </div>
      </ed-modal>

    </div>
</template>

<script>

    import EdTable from 'common/table'
    import EdModal from 'common/modal'
    import EdForm from 'common/form'
    import Rest from 'common/rest'
    import LogEmail from 'appsWeb/log/email/index'
    import FormItems from '../_form/lote-email-cadastro'

    export default {
        name:"esocial-lotes-email",
        mixins:[Rest],
        components:{EdTable,EdModal,EdForm,LogEmail},
        props:{
          parent:{
            type:Object,
            default:function () { return {} }
          },
          showForm:{
            type:Boolean,
            default:function () { return false }
          }
        },

        watch:{
          'parent.formData.id'(){
          },
          showForm(){
            this.showFormList = !this.showFormList;
          }
        },
        data () {
          return {
            config:{
              click:{
              },
              loading:{
                save:false,
              },
              list:{
              }
            },
            response:{},
            pagination:{},
            tableHead:[
              {
                key: 'destinatario',
                sortable: true,
						    label: 'Destinatário',
              },
              {
		            key: 'tipo_status',
                label: 'Status',
               },
              {
		            key: 'updated_at',
					    	sortable: true,
						    show_user:true,
						    label: 'Atualização',
		          },
            ],
            formData:{
              destinatario:null,
            },
            tableData:[],
            formItems:[],
            showFormList:false,
            showFormRegister:false,
          }
        },

        created(){
          
        },

        mounted() {
           this.formItems = FormItems
        },

        methods:{

          onRegister(){
            this.showFormRegister = !this.showFormRegister;
          },
          
          salvar(){

            this.config.loading.save = true;
            this.response = {};

            this.post('esocial/lotes/'+this.parent.formData.id+'/email',this.formData).then((result)=>{
              
              this.config.loading.save = false;

              result = result[0];
              this.response = result;

              if(result.status == 200){
                this.edMsg('Email cadastrado com sucesso')
                this.showFormRegister = !this.showFormRegister;
                this.$root.$session.event = 'LogEmailNotifyEvent';
              }

            });

          }
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?fe28db38